<template>
  <div>
    <vs-table :data="data">

      <template slot="thead">
        <vs-th :class="{'float-right': title === $t('maintenancePayments.table.amount')}" :key="i"
               class="text-base"
               v-for="(title, i) in header">{{ title }}
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indexTr" v-for="(tr, indexTr) in data" :class="tr.class">
          <vs-td v-if="!tr.name" :data="tr.paid_at" class="whitespace-pre">
            {{ tr.paid_at | fromShortDate }}
          </vs-td>
          <vs-td v-if="tr.name" :data="tr.name" class="whitespace-pre">
            <span class="font-bold">{{ tr.name }}</span>
          </vs-td>
          <vs-td class="text-right" :data="tr.amount">
            <span :class="{'font-bold': tr.name}">{{ tr.amount }}{{ tr.currency | currency}}</span>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
  export default {
    name: 'MaintenanceTransactionsTable',
    components: {},
    props: {
      header: {
        type: Array,
        required: true
      },
      data: {
        type: Array,
        required: true
      },
    }
  }
</script>

<style lang="scss" scoped>
</style>
